import type { MoodGoal, MoodType } from "@repo/shared-types";

export const MOOD_LABELS: Record<MoodType, { label: string; emoji: string; color: string }> = {
  anxious: { label: "Anxious", emoji: "😰", color: "#E2725B" },
  tired: { label: "Tired", emoji: "😴", color: "#8B7355" },
  stressed: { label: "Stressed", emoji: "😤", color: "#CD853F" },
  peaceful: { label: "Peaceful", emoji: "😌", color: "#7CB342" },
  energetic: { label: "Energetic", emoji: "⚡", color: "#FDD835" },
  sad: { label: "Sad", emoji: "😢", color: "#5C6BC0" },
  focused: { label: "Focused", emoji: "🎯", color: "#26A69A" },
  scattered: { label: "Scattered", emoji: "🤯", color: "#EF5350" },
};

export const GOAL_LABELS: Record<MoodGoal, { label: string; icon: string; category: string }> = {
  sleep: { label: "Better Sleep", icon: "🌙", category: "rest" },
  anxiety: { label: "Reduce Anxiety", icon: "🧘", category: "calm" },
  focus: { label: "Improve Focus", icon: "🎯", category: "mind" },
  energy: { label: "Boost Energy", icon: "⚡", category: "body" },
  peace: { label: "Inner Peace", icon: "🕊️", category: "spirit" },
  wisdom: { label: "Gain Wisdom", icon: "📚", category: "mind" },
  "stress-relief": { label: "Stress Relief", icon: "🌿", category: "calm" },
};
